module.exports = __webpack_public_path__ + "img/partly-cloudy-night.505920ed.svg";